module.exports = __webpack_public_path__ + "media/mypage/images/special/006-5a6394113b4b49a47e5031916f148470.jpg";